import { render, staticRenderFns } from "./BackgroundColorEditor.vue?vue&type=template&id=2134bab8&scoped=true"
import script from "./BackgroundColorEditor.vue?vue&type=script&lang=js"
export * from "./BackgroundColorEditor.vue?vue&type=script&lang=js"
import style0 from "./BackgroundColorEditor.vue?vue&type=style&index=0&id=2134bab8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2134bab8",
  null
  
)

export default component.exports